import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { MaxLength, NotBlank } from '@hvlng/framework-bff/core';
import { HvlMapConverter } from '@hvlng/framework-bff/util';
import { TextModel } from './text-model';

@JsonObject('KovanHrCodeTextModel')
export class CodeTextModel extends HvlBaseModel {
    @MaxLength(25)
    @NotBlank()
    @JsonProperty('code', String, true)
    code: string = null;

    @JsonProperty('detailMap', HvlMapConverter, true)
    detailMap: Map<string, TextModel> = new Map<string, TextModel>();

    @MaxLength(50)
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @MaxLength(250)
    @JsonProperty('longText', String, true)
    longText: string = null;
}
